export default __webpack_public_path__ + "static/media/add-group-as-giver.370a72c3.png";